// extracted by mini-css-extract-plugin
export var title = "line-item-module--title--228Op";
export var variant = "line-item-module--variant--31P0F";
export var remove = "line-item-module--remove--2ZvaX";
export var totals = "line-item-module--totals--38d7K";
export var priceColumn = "line-item-module--priceColumn--1ad14";